import type { UserPlan } from "@/types/tax";

export type SubscriptionCheckoutPlan = Exclude<UserPlan, "free">;

export function planLabel(plan: UserPlan) {
  if (plan === "pro_plus") return "Pro Plus";
  if (plan === "pro") return "Pro";
  return "Free";
}

export function isPaidPlan(plan: UserPlan) {
  return plan === "pro" || plan === "pro_plus";
}

export function scanLimitForPlan(plan: UserPlan) {
  if (plan === "pro_plus") return 150;
  if (plan === "pro") return 50;
  return 0;
}
